export default __webpack_public_path__ + "static/media/fb.e51fbc69.svg";